import { render, staticRenderFns } from "./Redirect360.vue?vue&type=template&id=1564168d&"
import script from "./Redirect360.vue?vue&type=script&lang=js&"
export * from "./Redirect360.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports